
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-conditions/[slug]",
      function () {
        return require("private-next-pages/medical-conditions/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical-conditions/[slug]"])
      });
    }
  